import { AppType, appType, supportedAppVersion } from "../global/appInfo.js";
import { APP_VERSION_REQUIREMENTS } from "../appVersionRequirements.js";
import type { NexusHandler } from "@otto-ec/global-resources/nexus";
import {DownloadImageError, DownloadImageErrorCause, parseDownloadImageErrorCause} from "./downloadImageError.js";
import {media, type Media} from "./index.js";

const imageDownloadCallbackPathAndName = "otto.apps.media.downloadImageResult";
const downloadImagePromises: {
    [key: string]: {
        resolve: () => void;
        reject: (error: Error) => void;
    };
} = {};

export const downloadImage: NexusHandler<Media["downloadImage"]> = async (imgUrl: string, openImageOnSuccess: boolean) => {
    const isSupported = await supportedAppVersion(APP_VERSION_REQUIREMENTS.downloadImage)
    if (appType() == AppType.ANDROID && isSupported && window.o_apps_android?.downloadImage) {
        return new Promise<void>((resolve, reject) => {
            downloadImagePromises[imgUrl] = { resolve, reject };
            window.o_apps_android?.downloadImage?.(imgUrl, openImageOnSuccess, imageDownloadCallbackPathAndName)
        })
    }
    if (appType() == AppType.IOS && isSupported && window.webkit?.messageHandlers?.downloadImage) {
        return new Promise<void>((resolve, reject) => {
            downloadImagePromises[imgUrl] = { resolve, reject };
            window.webkit?.messageHandlers?.downloadImage?.postMessage({imgUrl, openImageOnSuccess, imageDownloadCallbackPathAndName});
        })
    }
    return Promise.reject(new DownloadImageError(DownloadImageErrorCause.FeatureNotSupported));
}

export const downloadImageResult: NexusHandler<Media["downloadImageResult"]> = (imgUrl: string, isSuccessful: boolean, errorCode?: string) => {
    const promise = downloadImagePromises[imgUrl];
    if (promise) {
        if (isSuccessful) {
            promise.resolve();
        } else {
            promise.reject(new DownloadImageError(parseDownloadImageErrorCause(errorCode)));
        }
    }
}

media.assignNamespace({downloadImage, downloadImageResult})
